import { DateRangePicker, defaultTheme, Provider, } from '@adobe/react-spectrum'
import { useSearchParams } from "react-router-dom"


function formatDateForFilter(date) {
  const day = Number(date.day) > 9 ? date.day : `0${date.day}`
  const month = Number(date.month) > 9 ? date.month : `0${date.month}`
  return `${date.year}-${month}-${day}`
}

export default function DateRangeFilter({ label }) {
  const [searchParams, setSearchParams] = useSearchParams()
  const handleChange = ({ start, end }) => {
    searchParams.set('date_Gte', formatDateForFilter(start))
    searchParams.set('date_Lte', formatDateForFilter(end))
    setSearchParams(searchParams)
  }

  const handleClearBtn = () => {
    searchParams.delete('date_Gte')
    searchParams.delete('date_Lte')
    setSearchParams(searchParams)
  }

  return (
      <Provider theme={defaultTheme}>
        <div className="relative">
          <DateRangePicker
              label={label}
              onChange={handleChange}/>
          {
              searchParams.has('date_Gte') &&
              <div className="absolute bottom-1.5 right-10 ">
                <button onClick={handleClearBtn} className="text-gray-500">
                  X
                </button>
              </div>
          }

        </div>
      </Provider>
  )
}